<template>
	<div v-if="show" @click.self="dismissModal()" class="fixed pin z-50 overflow-hidden bg-smoke-lighter flex">
		<div class="relative bg-grey-lightest shadow-modal w-full max-w-2xl m-auto flex-col flex rounded">
			<div class="w-full bg-green-light py-1 rounded-t"></div>
			<CollectionSamplesMap
				v-if="order"
				@closeModal="dismissModal()"
				:page_id="page_id"
			/>
			<SelectOrder
				v-else-if="showSelectOrder"
				@goBack="showSelectOrder = false"
				@closeModal="dismissModal()"
			/>
			<SelectCustomer
				v-else-if="!customer_id && !year"
				@closeModal="dismissModal()"
			/>
			<SelectSampling
				v-else-if="customer_id && !year"
				@closeModal="dismissModal()"
				@selectOrder="showSelectOrder = true"
			/>
			<SamplingMap
				v-else-if="customer_id && year"
				@closeModal="dismissModal()"
				:page_id="page_id"
			/>
		</div>
	</div>
</template>

<script>
import SelectCustomer 		from '@/components/customersampling/SelectCustomer.vue'
import SelectSampling 		from '@/components/customersampling/SelectSampling.vue'
import SamplingMap 			from '@/components/customersampling/SamplingMap.vue'
import SelectOrder 			from '@/components/customersampling/SelectOrder.vue'
import CollectionSamplesMap	from '@/components/customersampling/CollectionSamplesMap.vue'

import { mapGetters } from 'vuex'

export default {

	components: {
		SelectCustomer,
		SelectSampling,
		SamplingMap,
		SelectOrder,
		CollectionSamplesMap
	},

	data() {
		return {
			show: false,
			showSelectOrder: false,
			page_id: null,
		}
	},

	computed: {
		...mapGetters({
			customer_id:	'customer/customer_id',
			year:			'customer/year',
			order:			'customer/order',
		})
	},

	mounted() {
		bus.$on('open-customer-sampling-modal', this.openModal)
		bus.$on('close-customer-sampling-modal', this.dismissModal)
	},

    beforeDestroy() {
        bus.$off('open-customer-sampling-modal')
        bus.$off('close-customer-sampling-modal')
    },

	methods: {
		dismissModal() {
			this.show = false
			document.getElementById("body").className = "";
		},

		openModal(page_id = null) {
			this.page_id = page_id
			this.show = true
			document.getElementById("body").className = "overflow-y-hidden";
			bus.$emit('deselect')
		}
	}
}
</script>